import { UnitActivityAddinName, UnitActivityViewName } from '@addins/core/core';
import { SettingOpenerService } from '@addins/core/settings';
import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { EnvironmentService } from '@services/environment/environment.service';
import { Events } from '@services/events/events.service';
import { CompletionHandler } from '@services/initializer/completion-handler';
import { Initializer } from '@services/initializer/initializer.service';
import { LogoutService } from '@services/logout/logout.service';
import { NavService } from '@services/navigation/navigation.service';
import { MyUnitService } from '@services/unit-activity/my-unit/my-unit.service';
import { ViewConfigurationService } from '@services/view-configuration/view-configuration.service';
import { ViewSelectorService } from '@services/view-selector/view-selector.service';
import { ADDIN_VIEW_EVENT_KEY, AddinView } from '@techwan/ionic-core';
import { HomeAccessMenuService } from '../../services/home-access-menu/home-access-menu.service';

@Component({
  templateUrl: 'simple-home.component.html',
  styleUrls: ['simple-home.component.scss'],
  providers: [LogoutService]
})
@AddinView({
  name: 'SimpleHome'
})
export class SimpleHomeComponent extends CompletionHandler {
  private _booted: boolean;
  get booted(): boolean {
    return this._booted === true;
  }

  get name(): string {
    return this._environmentService.getConfig().name;
  }

  get unitActivity(): UnitActivity {
    return this.booted && this._myUnitService.mine;
  }

  isTablet = this._platform.is('tablet');

  constructor(
    protected initializer: Initializer,
    private readonly _events: Events,
    private readonly _myUnitService: MyUnitService,
    private readonly _navService: NavService,
    private readonly _platform: Platform,
    private readonly _logoutService: LogoutService,
    private readonly _viewConfiguration: ViewConfigurationService,
    private readonly _environmentService: EnvironmentService,
    private readonly _homeAccessMenuService: HomeAccessMenuService,
    private readonly _settingOpener: SettingOpenerService,
    private readonly _viewSelector: ViewSelectorService
  ) {
    super(initializer);
    this._homeAccessMenuService.setup(SimpleHomeComponent);
  }

  openMyCard() {
    this._events.publish(ADDIN_VIEW_EVENT_KEY, 'singlecallcard/PageView', {
      card: this.unitActivity.callcard
    });
  }

  openMyUnit() {
    this._navService.get().push(this._viewSelector.getView(`${UnitActivityAddinName}/${UnitActivityViewName}`).element);
  }

  openMap() {
    this._events.publish(ADDIN_VIEW_EVENT_KEY, this._viewConfiguration.getMapName());
  }

  logout() {
    this._logoutService.logout();
  }

  showSettings(): Promise<void> {
    return this._settingOpener.open();
  }

  displayMenu() {
    const hideMenu = this._environmentService.get('hideMenu');
    if (typeof hideMenu === 'boolean') {
      return hideMenu;
    } else if (typeof hideMenu === 'string') {
      return !this._platform.is(hideMenu as any);
    }

    return true;
  }

  protected $onComplete() {
    this._booted = true;
  }
}
